<template>
  <div :class="['UIContentSwitcherButton']">
    <button
      type="button"
      :class="[
        'UIContentSwitcherButton__switch',
        {
          'UIContentSwitcherButton__switch--is-active': isActive,
          'UIContentSwitcherButton__switch--is-disabled': isDisabled,
        },
      ]"
      :isDisabled="isDisabled"
    >
      <slot />
    </button>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  isActive?: boolean
  isDisabled?: boolean
}>()
</script>

<style scoped lang="scss">
.UIContentSwitcherButton {
  width: 100%;
  min-width: 4rem;
  display: flex;
  justify-content: center;
  white-space: nowrap;
  position: relative;
  cursor: pointer;

  .UIContentSwitcherButton__switch {
    @include bodyText();
    font-weight: 600;
    padding: 0.75rem 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    @include trans(0.2s);
    text-decoration: none;
    background: none;
    border: none;
    box-shadow: none;
    transition: all 0.2s;
    width: 13.875rem;
    color: $color-ui-neutral-600;
    border-radius: 0.5rem;

    &:hover {
      color: $color-ui-neutral-800;
    }

    &--is-active {
      color: $color-white;
      background: $color-ui-accent-main !important;
      font-weight: 700;
      background: #fff;
      box-shadow: 0 2px 8px 0 rgba(16, 30, 54, 0.06);
      border: 1.5px solid #d3d6e2;
      z-index: 1;
      position: relative;

      &:hover {
        color: $color-white;
      }
    }

    &--is-disabled {
      background: #f5f6fa;
      border-color: #dbdfea;
      color: #b7c2d0;
      border-radius: 0.5rem;
      pointer-events: none;
      cursor: default;
    }
  }
}
</style>
